import { Field, TextInput, TextArea, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";

export default function EditAudience({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setItem = (i, v) => {
    const items = [...(value.items || [])];
    items[i] = { ...items[i], text: v };
    set("items", items);
  };
  const addItem = () => set("items", [...(value.items || []), { text: "Nova dor/desejo do público" }]);
  const removeItem = (i) => set("items", (value.items || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Para Quem É (Público-Alvo)">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="audience-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="audience-title-input" /></Field>
        <Field label="Subtítulo"><TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={2} testId="audience-subtitle-input" /></Field>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Itens (dores / desejos)</span>
            <ListAddBtn onClick={addItem} label="Adicionar" testId="audience-add-item" />
          </div>
          <div className="space-y-3">
            {(value.items || []).map((it, i) => (
              <div key={i} className="flex items-center gap-3" data-testid={`audience-item-row-${i}`}>
                <div className="flex-1">
                  <TextInput value={it.text} onChange={(v) => setItem(i, v)} testId={`audience-item-input-${i}`} />
                </div>
                <ListRemoveBtn onClick={() => removeItem(i)} testId={`audience-item-remove-${i}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
